import React, { useState, useEffect, useRef } from "react";
import { Row, Col } from "react-bootstrap";
import * as echarts from "echarts";
import AADService from "../../funcionesAuth.js";

const SankeyGraph = ({ data }) => {
  const chartRef = useRef(null);
  const chartInstanceRef = useRef(null);

  useEffect(() => {
    if (!chartRef.current) return;

    // Inicializa el gráfico solo si no existe
    if (!chartInstanceRef.current) {
      chartInstanceRef.current = echarts.init(chartRef.current);
    }

    const option = {
      title: {
        text: "Estado actual de las evaluaciones",
        left: "center",
        top: 20, 
        textStyle: {
          fontSize: 24, 
          fontWeight: "bold",
        },
      },
      tooltip: {
        trigger: "item",
        triggerOn: "mousemove",
      },
      series: [
        {
          type: "sankey",
          layout: "horizontal",
          top: 60,
          data: [
            { name: "Evaluaciones" },
            { name: "Con responsable" },
            { name: "Sin responsable" },
            { name: "Con infraestructura" },
            { name: "Sin infraestructura" },
            { name: "Con vulnerabilidades" },
            { name: "Sin vulnerabilidades" },
            { name: "Con efectos" },
            { name: "Sin efectos" },
            { name: "Con controles" },
            { name: "Sin controles" },
          ],
          links: data,
          emphasis: {
            focus: "adjacency",
          },
          lineStyle: {
            color: "gradient",
            curveness: 0.5,
          },
          label: {
            color: "#000",
          },
        },
      ],
    };

    chartInstanceRef.current.setOption(option);

    return () => {
      chartInstanceRef.current?.dispose();
      chartInstanceRef.current = null;
    };
  }, [data]);

  return <div ref={chartRef} style={{ width: "100%", height: "400px" }} />;
};

const ResumenNewEvaluaciones = () => {
  const [DataResumen, setDataResumen] = useState([]);
  const AzureADService = new AADService();
  const token = AzureADService.getToken();
  
  useEffect(() => {
    const obtenerResumen = async () => {
      const result = await fetch(
        process.env.REACT_APP_API_URL +
          "evaluacion/nuevaevaluacion/bandeja/0/" +
          localStorage.getItem("idcompania") +
          "/",
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
          },
        }
      );
      if (result.ok) {
        const datResumen = await result.json();
        setDataResumen(datResumen);
      } else {
        console.error("Error al obtener datos:", result.status);
      }
    };
    obtenerResumen();
  }, []);

  return (
    <div>
      {DataResumen.length > 0 ? (
        <SankeyGraph data={DataResumen} />
      ) : (
        <p>Cargando datos...</p>
      )}
    </div>
  );
};

export default ResumenNewEvaluaciones;
